import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  originalCompanies: null,
  companies: null,
  status: 'idle',
  error: null,
  addCompanyStatus: 'idle',
  addCompanyError: null,
  companyDetails: null,
  editCompanyStatus: 'idle',
  editCompanyError: null,
  selectedCompanyID: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    getAllCompaniesStart: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    getAllCompaniesSuccess: (state, action) => {
      state.status = 'success';
      state.companies = action.payload.data;
      state.originalCompanies = action.payload.data;
      state.error = null;
    },
    getAllCompaniesFailure: (state, action) => {
      state.status = 'fail';
      state.error = action.payload.message;
    },
    addCompanyStart: (state) => {
      state.addCompanyStatus = 'loading';
      state.editCompanyStatus = 'loading';
      state.addCompanyError = null;
      state.editCompanyError = null;
    },
    addCompanySuccess: (state) => {
      state.addCompanyStatus = 'success';
      state.addCompanyError = null;
    },
    addCompanyFailure: (state, action) => {
      state.addCompanyStatus = 'fail';
      state.addCompanyError = action.payload.message;
    },
    fetchCompanyDetailsStart: (state) => {
      state.companyDetails = null;
    },
    fetchCompanyDetailsSuccess: (state, action) => {
      state.companyDetails = action.payload.data;
    },
    editCompanyStart: (state) => {
      state.addCompanyStatus = 'loading';
      state.editCompanyStatus = 'loading';
      state.addCompanyError = null;
      state.editCompanyError = null;
    },
    editCompanySuccess: (state) => {
      state.editCompanyStatus = 'success';
      state.editCompanyError = null;
    },
    editCompanyFailure: (state, action) => {
      state.editCompanyStatus = 'fail';
      state.editCompanyError = action.payload.message;
    },
    setSelectedCompanyID: (state, action) => {
      state.selectedCompanyID = action.payload;
    },
    resetCompanyDetails: (state) => {
      state.companyDetails = null;
    },
    resetSnackbar: (state) => {
      state.addCompanyStatus = 'idle';
      state.editCompanyStatus = 'idle';
      state.addCompanyError = null;
      state.editCompanyError = null;
    },
    setFilteredCompanyList: (state, action) => {
      state.companies = action.payload;
    },
  },
});

export const {
  getAllCompaniesStart,
  getAllCompaniesSuccess,
  getAllCompaniesFailure,
  addCompanyStart,
  addCompanySuccess,
  addCompanyFailure,
  fetchCompanyDetailsStart,
  fetchCompanyDetailsSuccess,
  editCompanyStart,
  editCompanySuccess,
  editCompanyFailure,
  setSelectedCompanyID,
  resetCompanyDetails,
  resetSnackbar,
  setFilteredCompanyList,
} = companySlice.actions;

export default companySlice.reducer;
